<template>
  <div class="breadcrumb-container">
    <el-breadcrumb separator="/" class="nav-breadcrumb-wrap">
      <el-breadcrumb-item v-for="(item, index) in breadList" :key="item.path">
        <router-link v-if="item.path !== path && index >= 1"
                     :to="item.path === '' ? '/' : {path: item.path, query: item.query}">
          {{ item.title }}
        </router-link>
        <span v-else>{{ item.title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>

export default {
  name: 'NavBreadcrumb',
  data() {
    return {
      path: '',
      breadList: [],
      // 缓存一份路由的参数
      routeQuery: {}
    }
  },
  computed: {
    /**
     * 菜单数据副本容器（用于关联查找数据，包含全量路由配置）
     */
    menuCopyRoutes() {
      return this.$store.getters.menuCopyRoutes;
    },
  },
  watch: {
    $route() {
      this.handleBreadcrumb()
    }
  },
  created() {
    this.handleBreadcrumb()
  },
  methods: {
    handleBreadcrumb() {
      let breadList = []
      this.path = this.$route.path
      const query = this.$route.query
      // 默认应该通过route处理，但是存在roue和menu不一致场景，比如外开内情况
      let menuRoute = this.menuCopyRoutes[this.path];
      while(menuRoute) {
        if(menuRoute.title) {
          breadList.push({...menuRoute});
        }
        menuRoute = this.menuCopyRoutes[menuRoute.parentPath];
      }
      breadList = breadList.reverse();
      this.breadList = breadList;
    //   const breadList = [{meta: {title: '首页'}}]
    //   // 最终要展示的面包屑菜单
    //   const routes = []
    //   this.$route.matched.forEach(item => {
    //     if (item.title) {
    //       // 过滤掉一层重复的菜单
    //       if (!routes.find(r => r.path === item.path)) {
    //         routes.push(item)
    //       }
    //     }
    //   })
    //   routes.forEach(item => {
    //     breadList.push(item)
    //     if (item.path === this.path && !this.$util.isEmptyObject(query)) {
    //       this.routeQuery[item.path] = query
    //     }
    //   })
    //   // 将访问路径对应的 query 参数传递过去，刷新的时候用得到
    //   this.breadList = breadList.map(item => {
    //     if (this.routeQuery[item.path]) {
    //       return {
    //         ...item,
    //         query: this.routeQuery[item.path]
    //       }
    //     }
    //     return item
    //   })
    }
  }
}
</script>

<style lang="less" scoped>
.breadcrumb-container {
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
</style>
